import {cookieUtils} from "@utilities/cookie-utils/cookie-utils";
import {SalToast} from "@utilities/sal-toast/sal-toast";

let options = {
    globalProductComboPanelClass: 'global-product-combo-panel',
    counterClass: 'panel__count',
    toastGroup: 'productCombo',
    buttonEmptyClass: 'button--primary',
    buttonFilledClass: 'button--brand',
    cookieDelimiterRegEx: /combo/g
}

const methods = {
    productCount: () => {
        const productCombos = cookieUtils.getCookie(`productCombo_${window.market}`);
        return productCombos ? (productCombos.match(options.cookieDelimiterRegEx) || []).length : 0;
    },
    setCount: (reference, count) => {
        reference.querySelector(`.${options.counterClass}`).innerText = `(${count})`;
    },
    registerToShopBroadcast: (reference) => {
        const updateCount = function() {
            const changedCount = methods.productCount();
            const button = reference.querySelector('.button');
            if (!button) {
                return;
            }
            if (changedCount > 0) {
                button.classList.remove(options.buttonEmptyClass)
                button.classList.add(options.buttonFilledClass)
            } else {
                button.classList.remove(options.buttonFilledClass)
                button.classList.add(options.buttonEmptyClass)
            }
            methods.setCount(reference, changedCount);
        };

        updateCount();
        const productComboAdded = function() {
            methods.showToast();
            methods.animateGlobalProductComboPanel(reference, 'open');
        }

        window.addEventListener('productComboadd', updateCount);
        window.addEventListener('productComboadd', productComboAdded);
        window.addEventListener('productComboremove', updateCount);
    },
    animateGlobalProductComboPanel: (reference, direction = 'close') => {
        if (direction === 'open') {
            reference.classList.remove('hidePanel')
            reference.classList.add('showPanel')
            return
        }

        reference.classList.remove('showPanel')
        reference.classList.add('hidePanel');
    },
    showToast: () => {
        if (!window.toasts) {
            window.toasts = new SalToast();
        }

        window.toasts.createToast(window.pimLocalization.combopanel.body, '', window.toasts.types.INFO, {
            label: window.pimLocalization.combopanel.button,
            link: window.page_dealerrequest,
            target: '_self',
            additionalClass: 'button button--primary'
        }, null, null, options.toastGroup);
    }
}

const globalProductComboPanel = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);
        const globalProductComboPanelReference = document.querySelector(`.${options.globalProductComboPanelClass}`);
        if (globalProductComboPanelReference === null) {
            new Error('ProductComboPanel not found');
        }

        methods.registerToShopBroadcast(globalProductComboPanelReference);

        window.addEventListener('toastClosed', function(e) {
            if (e.detail === options.toastGroup) {
                window.setTimeout(function() {
                    methods.animateGlobalProductComboPanel(globalProductComboPanelReference, 'close')
                }, 2000);
            }
        });
    }
};

export { globalProductComboPanel }
